'use client';
import { useSearchParams } from 'next/navigation';

import { gameDayLinks } from '@/modules/league/new-components/constants';
import { NavLink } from '@/modules/league/new-components/header/NavigationTabs/NavLink';
import { NavLinkMobile } from '@/modules/league/new-components/header/NavigationTabs/NavLinkMobile';
import { NavigationTabsProps } from '@/modules/league/new-components/types';

const NavigationTabs = ({ isRatingLeagueShowStats }: NavigationTabsProps) => {
  const searchParams = useSearchParams();
  const pageType = searchParams?.get('tab') || 'rsvp';
  const newSearchParams = new URLSearchParams(searchParams?.toString());
  const sequenceNumber = newSearchParams.get('sequenceNumber');

  if (pageType === 'change-scores') return null;

  return (
    <>
      {/* Mobile Navigation */}
      <div className='flex w-full justify-center md:hidden'>
        <div className='flex w-full max-w-md bg-white text-base font-bold'>
          <NavLinkMobile
            isMobile
            pageType={pageType}
            isRatingLeagueShowStats={isRatingLeagueShowStats}
            sequenceNumber={sequenceNumber}
          />
        </div>
      </div>

      {/* Desktop Navigation */}
      <div className='hidden w-full justify-between gap-4 pt-2 md:flex'>
        {gameDayLinks.map((link) => (
          <NavLink
            key={link.type}
            text={link.label}
            currentType={link.type}
            pageType={pageType}
            isStats={isRatingLeagueShowStats}
            sequenceNumber={sequenceNumber}
          />
        ))}
      </div>
    </>
  );
};

export default NavigationTabs;
